import { getCookie } from '../../helper'
import { FirebaseDataService } from '../../services/firebase-data.service'
import store from '../../redux/store'
import { updateDataAction, updateDataActionInsights } from './emailSlice';
import { Http_service } from '../../services/http-service';


const user = getCookie('user').split('@')[0];
// const user = 'leightworks-prod'
const firebaseDataService = new FirebaseDataService()



export class EmailDataFetching {

  userData
  paidStatus
  personaStatus
  personaPaidStatus
  campaign_opt_paid
  CustomerEmailList;
  CustomerEmailList_All = []
  CustomerEmail_Labels = []

  senderName = "";
  senderEmail = "";
  name = "";
  email = "";
  emailSubject = "You left something behind";

  loading = true;
  Customer_Details_List;
  // Weeks
  Customer_Details_Labels = [];
  // Name, email, products list
  Customer_Details_Data_List = [];
  Curr_Customer_week;
  Curr_Customer_weekData = [];
  Send_Email_Btn_Disabled = false;
  Sender_Details_Error = false;
  Sender_Details_Error_ErrorMsg =
    "Sender Name & Email fields are required";
  Send_Email_Success_Msg = false;

  companyDetails = {};
  companyGenericProducts = [];
  todayGraphNode;
  todaySentEmail_Data;
  email_sent_label = "Not Sent";
  email_sent_status = false;
  eamil_sent_timestamp;
  id_email_status = [];
  emailSent_updated_status = false;
  id_email_status_obj = {};

  start_date = { year: 2022, month: 1, day: 1 };
  max_last_date = { year: 2022, month: 11, day: 12 };
  selected_date;
  maxDate;

  data_not_found_status = false;
  data_not_found_label = "Oops! Data Not Found";
  today
  today_day
  today_month
  today_year

  sentEmailInsight_labels = []
  sentEmailInsight_data = []
  sendBlue_sentEmail_data = {}
  sendBlue_ApiCall = 0
  check_status_sentEmail_display = true;

  totalUser = 0;
  emailNotSent = 0;
  emailSent = 0;
  emailSentOpened = 0;
  emailSentClicked = 0;
  emailSentHardBounces = 0;
  emailNotSent_perc = 100;
  emailSent_perc = 0;
  emailSentOpened_perc = 0;
  emailSentClicked_perc = 0;
  emailSentHardBounces_perc = 0;
  adminView = true;

  http_service

  constructor() {

    this.today = new Date();
    this.today_day = String(this.today.getDate());
    this.today_month = String(this.today.getMonth() + 1);
    this.today_year = String(this.today.getFullYear());
    if (this.today_day.length == 1) {
      this.today_day = "0" + this.today_day;
    }
    if (this.today_month.length == 1) {
      this.today_month = "0" + this.today_month;
    }
    this.selected_date = new Date(
      `${this.today_year}/${this.today_month}/${this.today_day}`
    );
    this.maxDate = new Date(
      `${this.today_year}/${this.today_month}/${this.today_day}`
    );
    let todayNode = this.today_year + this.today_month + this.today_day;
    this.todayGraphNode = todayNode


  }



  graphSentEmailInsightsFetching = () => {
    return new Promise((resolve, reject) => {

      let statsObj = user + "/graph-sentEmailInsights";
      firebaseDataService
        .graphSentEmailInsights(statsObj, user, "graph-sentEmailInsights")
        .subscribe((data) => {
          this.sentEmailInsight_labels = Object.keys(data);
          this.sentEmailInsight_data = Object.values(data);

          if (data.hasOwnProperty(this.todayGraphNode)) {
            this.todaySentEmail_Data = data[this.todayGraphNode];

            if (this.todaySentEmail_Data["emailSent_Status"] === "true") {
              this.email_sent_label = "Sent";
              this.email_sent_status = true;
              this.eamil_sent_timestamp =
                this.todaySentEmail_Data["emailSent_time"];
              this.emailNotSent = 0;
              this.emailNotSent_perc = 0;
              this.emailSent = this.totalUser;
              this.emailSent_perc = 100;
            }
          }

          // weeks and data from email insights -> update state
          let all_weeks = this.sentEmailInsight_labels.map(value => {
            return value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8)
          })
          this.updateReduxStateInsights({
            insightWeeks: all_weeks,
            insightData: this.sentEmailInsight_data
          })

        })

      resolve();
    });
  }



  // Called First, determines if there is company data
  //
  graphCompanyDetailsFetching() {
    let statsObj = user + "/graph-companyDetails";
    firebaseDataService
      .graphCompanyDetails(statsObj, user, "graph-companyDetails")
      .subscribe((data) => {
        if (Object.keys(data).length === 0) {
          this.data_not_found_status = true;
        }
        // console.log("graphCompanyDetailsFetching", data);
        this.graphSendEmailsFetching();
        this.companyGenericProducts = data["genericProducts"];
        this.companyDetails = data;
        delete this.companyDetails["genericProducts"];
        // console.log(this.companyDetails)
        // console.log(this.companyGenericProducts)
      });
  }

  graphSendEmailsFetching() {

    let statsObj = user + "/graph-emailCustomer";
    firebaseDataService
      .graphSendEmailsDaily(statsObj, user, "graph-emailCustomer")
      .subscribe((data) => {

        if (Object.keys(data[0]).length === 0) {
          this.data_not_found_status = true;
        }
        this.loading = false;
        this.Customer_Details_List = data[0];
        this.Customer_Details_Labels = Object.keys(this.Customer_Details_List);

        this.Customer_Details_Data_List = Object.values(this.Customer_Details_List)

        let last_valid_date = this.Customer_Details_Labels[this.Customer_Details_Labels.length - 1]

        if (this.Customer_Details_Labels.includes(this.todayGraphNode)) {
          this.Curr_Customer_week =
            this.Customer_Details_Labels[
            this.Customer_Details_Labels.length - 1
            ];
          this.Curr_Customer_weekData =
            this.Customer_Details_Data_List[
            this.Customer_Details_Data_List.length - 1
            ];
          this.Curr_Customer_weekData = this.check_for_3products(
            this.Curr_Customer_weekData
          );

          this.totalUser = this.Curr_Customer_weekData.length;
          this.emailNotSent = this.Curr_Customer_weekData.length;
        } else {
          this.selected_date = `${last_valid_date.slice(0, 4)}-${last_valid_date.slice(4, 6)}-${last_valid_date.slice(6, 8)}`
          this.SelectedDateEmailFetch()
        }

        // Weeks and customer data 
        // Update redux store with data
        let all_weeks = this.Customer_Details_Labels.map(value => {
          return value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8)
        })
        this.updateReduxState({
          dates: all_weeks,
          customerLists: this.Customer_Details_Data_List,
          dataNotFoundStatus: this.data_not_found_status,
        })

      })


  }








  SelectedDateEmailFetch() {
    this.email_sent_label = "Not Sent";
    let new_selected_date = this.todayGraphNode;
    this.eamil_sent_timestamp = ""
    this.email_sent_status = false
    this.emailSent_updated_status = false;

    this.emailSent = 0;
    this.emailSentOpened = 0;
    this.emailSentClicked = 0;
    this.emailSentHardBounces = 0;
    this.emailNotSent_perc = 100;
    this.emailSent_perc = 0;
    this.emailSentOpened_perc = 0;
    this.emailSentClicked_perc = 0;
    this.emailSentHardBounces_perc = 0;

    if (typeof this.selected_date === "string") {
      new_selected_date = this.selected_date;
      new_selected_date = new_selected_date.replaceAll("-", "");
    }

    if (this.Customer_Details_Labels.includes(new_selected_date)) {
      let index = this.Customer_Details_Labels.indexOf(new_selected_date);
      this.Curr_Customer_week = this.Customer_Details_Labels[index];
      this.Curr_Customer_weekData = this.Customer_Details_Data_List[index];
      this.Curr_Customer_weekData = this.check_for_3products(
        this.Curr_Customer_weekData
      );
      this.totalUser = this.Curr_Customer_weekData.length;
      this.emailNotSent = this.Curr_Customer_weekData.length;

      this.update_Email_Insights_Data(new_selected_date)

    } else {
      this.Curr_Customer_week = new_selected_date;
      this.Curr_Customer_weekData = [];
      this.email_sent_status = false;
      this.email_sent_label = "Not Sent";
      this.emailSent_updated_status = false
    }

  }




  check_for_3products(weekdata) {
    weekdata.map((i) => {
      let products = i["products"];
      switch (products.length) {
        case 0:
          products.push(this.companyGenericProducts[0]);
          products.push(this.companyGenericProducts[1]);
          products.push(this.companyGenericProducts[2]);
        case 1:
          products.push(this.companyGenericProducts[0]);
          products.push(this.companyGenericProducts[1]);
          break;
        case 2:
          products.push(this.companyGenericProducts[0]);
          break;
      }
      i["products"] = products;
    });
    return weekdata;
  }





  update_Email_Insights_Data(new_selected_date) {
    if (this.sentEmailInsight_labels.includes(new_selected_date)) {
      let ind = this.sentEmailInsight_labels.indexOf(new_selected_date)
      this.todaySentEmail_Data = this.sentEmailInsight_data[ind]

      if (this.todaySentEmail_Data["emailSent_Status"] === "true") {
        this.email_sent_label = "Sent";
        this.email_sent_status = true;
        this.eamil_sent_timestamp = this.todaySentEmail_Data["emailSent_time"];
        this.emailNotSent = 0;
        this.emailNotSent_perc = 0;
        this.emailSent = this.totalUser;
        this.emailSent_perc = 100;
      }

    } else {
      this.email_sent_status = false;
      this.email_sent_label = "Not Sent";
      this.emailSent_updated_status = false
    }

  }






  async updateReduxState(data) {
    try {
      // Dispatch the action to update the Redux state
      store.dispatch(updateDataAction(data));
    } catch (error) {
      console.error('Error updating Redux state:', error);
    }
  }

  async updateReduxStateInsights(data) {
    try {
      // Dispatch the action to update the Redux state
      store.dispatch(updateDataActionInsights(data));
    } catch (error) {
      console.error('Error updating Redux state:', error);
    }
  }

}











